export const SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD = 'SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD';
export const SET_INC_ATTACHMENTS = 'SET_INC_ATTACHMENTS';

export const setSelectedAttachmentsForDownload = (attachemnts) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD, payload: attachemnts });
  };
};

export const resetSelectedAttachmentsForDownload = () => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD, payload: [] });
  };
};

export const setIncAttachments = (attachments) => {
  return (dispatch) => {
    dispatch({ type: SET_INC_ATTACHMENTS, payload: attachments });
  };
};

export default function reducer(
  state = {
    selectedDownloadAttachments: [],
    incAttachments: [],
  },
  action
) {
  switch (action.type) {
    case SET_SELECTED_ATTACHMENTS_FOR_DOWNLOAD:
      return {
        ...state,
        selectedDownloadAttachments: action.payload,
      };
    case SET_INC_ATTACHMENTS:
      return {
        ...state,
        incAttachments: action.payload,
      };
  }

  return state;
}
